import React from "react"
import { SwiperSlide } from "swiper/react"

import { Color } from "../../../../constants/V2/color"
import PillButton from "../../../elements/V2/Buttons/PillButton"
import GatsbyStoryblokImage from "../../../elements/V2/GatsbyStoryblokImage"
import Typography from "../../../elements/V2/Typography"

import { getAccentColor } from "@utils/V2/color"
getAccentColor

export type CategorySlideProps = {
  categoryHeadingText: string
  color?: Color.Charcoal | Color.White
  headingText?: string
  descriptionText?: string
  buttonText?: string
  buttonUrl?: string | YocoCom.YocoLink
  image?: string
  imageAlt?: string
}

const CategorySlide = ({
  color = Color.Charcoal,
  headingText,
  descriptionText,
  buttonText,
  buttonUrl,
  image,
  imageAlt,
}: CategorySlideProps) => {
  return (
    <SwiperSlide>
      <div className="flex flex-col-reverse gap-12 md:flex-row md:gap-24 lg:gap-32 xl:gap-40">
        <div className="content-center pr-48 md:w-1/2">
          {headingText && (
            <Typography
              size="h4"
              font="grotesk"
              weight="book"
              color={color}
              text={headingText}
              element="h4"
            />
          )}
          {descriptionText && (
            <Typography
              size="body-lg"
              font="grotesk"
              weight="book"
              color={color}
              className="pt-16"
              text={descriptionText}
            />
          )}
          {buttonText && buttonUrl && (
            <PillButton
              style="solid"
              size="medium"
              className="mt-32 w-fit"
              color={Color.Blue}
              text={buttonText}
              linkUrl={buttonUrl}
            />
          )}
        </div>
        {image && (
          <div className="flex content-center justify-center md:w-1/2">
            <GatsbyStoryblokImage
              aspectRatio="4:3"
              image={image}
              alt={imageAlt || "Category slide image"}
              quality={80}
              width={1000}
              className="sm:w-2/3 md:w-full"
              testId="category-slide-image"
            />
          </div>
        )}
      </div>
    </SwiperSlide>
  )
}

CategorySlide.displayName = "SwiperSlide"

export default CategorySlide
